module.exports = __webpack_public_path__ + "static/media/dforce.18085c75.svg";